import { useEffect } from "react";
import { signal } from "@preact/signals-react";
import date from "date-and-time";

import FormWizard from "components/MeForm/FormWizard";
import funcs from "tools/functions";
import ModelUpdateFolio from "./ModelUpdateFolio";
import { useWizardStore } from "store/wizardStore";
// import { useBtnLoading } from "store/btnLoading";
// import { Alert } from "components/Tools/Alert";
// import mainStore from "store/mainStore";
import proxy from "api/proxy";
import useChildStore from "store/childStore";
import dates from "tools/dates";

const msgAlert = signal(null);

function UpdateFolio({ onClose, parentRec }) {
  // const { setButtonLoading } = useBtnLoading();
  const { store, reset, updateWizard } = useWizardStore();
  const { record, reload } = useChildStore();

  useEffect(() => {
    updateWizard({ ...store, ...{ parentRec: parentRec } });
    // msgAlert.value = {};
  }, []);

  async function handleUpdateFolio() {
    const _data = funcs.recToTryton(store);
    const folioId = parentRec.id;
    const values = {};

    Object.entries(_data).forEach(([key, value]) => {
      if (value && key !== "parentRec") {
        values[key] = value;
      }
    });
    delete values.user;
    delete values.sale_device;
    delete values.operation_center;
    delete values.shop;
    delete values.overbooking;

    if (values?.departure_date || values?.arrival_date) {
      const nights = getNights(
        values.arrival_date || parentRec?.arrival_date,
        values.departure_date || parentRec?.departure_date,
      );
      values.nights_quantity = nights;
    }

    const args = {
      model: "hotel.folio",
      ids: [folioId],
      values: values,
      ctx: { overbooking: _data.overbooking },
    };
    const { error } = await proxy.save(args);

    if (error) {
      msgAlert.value = error.error;
      return false;
    }
    reset();
    reload();
    onClose(true);
  }

  function getNights(arrival, departure) {
    let arrival_date = arrival;
    let departure_date = departure;
    if (typeof arrival === "string") {
      arrival_date = dates.getTrytonDate2Js(arrival);
    }
    if (typeof departure_date === "string") {
      departure_date = dates.getTrytonDate2Js(departure);
    }
    return date.subtract(departure_date, arrival_date).toDays();
  }

  return (
    <div>
      {msgAlert.value && (
        <div className="bg-rose-200 rounded-md p-3 ml-4 my-2">
          {msgAlert.value}
        </div>
      )}
      <FormWizard
        key="hotel-booking-wizard-bill"
        ctxView={ModelUpdateFolio.ctxView(parentRec)}
        parentRec={{ record: record }}
        handleButton={handleUpdateFolio}
      />
    </div>
  );
}

export default UpdateFolio;
